import React, { useState } from 'react';

import CloseIcon from '@images/icons/x-mark.webp';

import './styles/promotions.scss';

import ReactMarkdown from 'react-markdown';
import CloudflareImage from '../cloudflare-image/CloudflareImage';
import usePromotionBanners from './usePromotionBanners';
import useIsMobile from '../../hooks/useIsMobile';
import { getObjectFromLocalStorage } from '../../utils/storage';

const getPromoCookieFromStorage = () => {
  const promoCookie = getObjectFromLocalStorage('promoCookie');
  if (promoCookie && promoCookie.cache_expiration > Date.now()) {
    return promoCookie;
  }
  return undefined;
};

const Promotions = React.memo(() => {
  const [showBanner, setShowBanner] = useState(false);
  const [promoCookie, setPromoCookie] = useState(getPromoCookieFromStorage());
  const isMobile = useIsMobile();

  const { dismissBanner } = usePromotionBanners({
    showBanner: showBanner,
    setShowBanner: setShowBanner,
    promoCookie: promoCookie,
    setPromoCookie: setPromoCookie,
    isMobile: isMobile,
  });

  return (
    showBanner && (
      <div className="promotions" data-aos="fade-down">
        <div>
          <p className="h4">
            <ReactMarkdown components={{ p: React.Fragment }} children={`${showBanner.sales_pitch.replace(/<br>/g, '')}`} />

            {(showBanner.sales_pitch.includes('<br>') || showBanner.sub_heading.includes('<br>')) && <br />}

            {showBanner.sub_heading && (
              <span>
                &nbsp;
                <ReactMarkdown components={{ p: React.Fragment }} children={`${showBanner.sub_heading.replace(/<br>/g, '')}`} />
              </span>
            )}
          </p>
        </div>

        <button type="button" className="close__panel" onClick={() => dismissBanner(showBanner.id)}>
          <CloudflareImage src={CloseIcon} alt="close" width="30" height="30" loading="lazy" decoding="async" />
        </button>
      </div>
    )
  );
});

export default Promotions;
